import { MutationOptions } from "@apollo/client";
import gql from "graphql-tag";
import { GraphQlMutationBuilder } from "../graphQL-mutation.builder";

export interface DashboardDeleted {
  dashboardUUID: string;
}

export class RemoveDashboardBuilder {
  private _DASHBOARDUUID: string;

  private get _mutation() {
    return gql`
      mutation deleteDashboard($dashboardUUID: String!) {
        deleteDashboard(uuid: $dashboardUUID) {
          uuid
        }
      }
    `;
  }

  public withDashboardUUID(dashboardUUID: string): this {
    this._DASHBOARDUUID = dashboardUUID;
    return this;
  }

  public build(): MutationOptions {
    const mutationParams: DashboardDeleted = {
      dashboardUUID: this._DASHBOARDUUID,
    };
    const graphQlMutationBuilder: GraphQlMutationBuilder =
      new GraphQlMutationBuilder();
    return graphQlMutationBuilder
      .withMutation(this._mutation)
      .withParams(mutationParams)
      .build();
  }
}
